const phoenixZipCodes = new Set([
  '85001',
  '85002',
  '85003',
  '85004',
  '85005',
  '85006',
  '85007',
  '85008',
  '85009',
  '85010',
  '85011',
  '85012',
  '85013',
  '85014',
  '85015',
  '85016',
  '85017',
  '85018',
  '85019',
  '85020',
  '85021',
  '85022',
  '85023',
  '85024',
  '85026',
  '85027',
  '85028',
  '85029',
  '85030',
  '85031',
  '85032',
  '85033',
  '85034',
  '85035',
  '85036',
  '85037',
  '85038',
  '85039',
  '85040',
  '85041',
  '85042',
  '85043',
  '85044',
  '85045',
  '85046',
  '85048',
  '85050',
  '85051',
  '85053',
  '85054',
  '85060',
  '85061',
  '85062',
  '85063',
  '85064',
  '85065',
  '85066',
  '85067',
  '85068',
  '85069',
  '85070',
  '85071',
  '85072',
  '85073',
  '85074',
  '85075',
  '85076',
  '85078',
  '85079',
  '85080',
  '85082',
  '85083',
  '85085',
  '85086',
  '85087',
  '85117',
  '85118',
  '85119',
  '85120',
  '85121',
  '85127',
  '85138',
  '85139',
  '85140',
  '85142',
  '85143',
  '85147',
  '85172',
  '85178',
  '85190',
  '85201',
  '85202',
  '85203',
  '85204',
  '85205',
  '85206',
  '85207',
  '85208',
  '85209',
  '85210',
  '85211',
  '85212',
  '85213',
  '85214',
  '85215',
  '85216',
  '85224',
  '85225',
  '85226',
  '85233',
  '85234',
  '85236',
  '85244',
  '85246',
  '85248',
  '85249',
  '85250',
  '85251',
  '85252',
  '85253',
  '85254',
  '85255',
  '85256',
  '85257',
  '85258',
  '85259',
  '85260',
  '85261',
  '85262',
  '85263',
  '85264',
  '85266',
  '85267',
  '85268',
  '85269',
  '85271',
  '85274',
  '85275',
  '85277',
  '85280',
  '85281',
  '85282',
  '85283',
  '85284',
  '85285',
  '85286',
  '85287',
  '85295',
  '85296',
  '85297',
  '85298',
  '85299',
  '85301',
  '85302',
  '85303',
  '85304',
  '85305',
  '85306',
  '85307',
  '85308',
  '85309',
  '85310',
  '85311',
  '85312',
  '85318',
  '85322',
  '85323',
  '85324',
  '85326',
  '85327',
  '85329',
  '85331',
  '85335',
  '85338',
  '85339',
  '85340',
  '85342',
  '85343',
  '85345',
  '85351',
  '85353',
  '85355',
  '85358',
  '85361',
  '85363',
  '85372',
  '85373',
  '85374',
  '85375',
  '85376',
  '85377',
  '85378',
  '85379',
  '85380',
  '85381',
  '85382',
  '85383',
  '85385',
  '85387',
  '85388',
  '85392',
  '85395',
  '85396',
]);
export const isPhoenixZipCode = (zipCode: string) =>
  phoenixZipCodes.has(zipCode);
